<template>
    <div class="cgs-app-worksheet">
        <div class="cgs-worksheet-header">
            <!-- <van-nav-bar left-text="返回" left-arrow @click-left="goBack" /> -->
            <van-nav-bar :border="true" title="工作流">
                <template #left>
                    <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
                </template>
            </van-nav-bar>
        </div>
        <div class="cgs-worksheet-list-content">
            <!-- <van-empty v-if="list.length == 0" description="暂无消息" /> -->
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <van-cell class="cell todo-cell" is-link to="/myprocess">
                    <template #title>
                        <div class="todo-cell-title">待处理</div>
                        <div class="todo-cell-content">{{`${daibanCount}个待办事项`}}</div>
                    </template>
                </van-cell>
                <van-cell class="cell" center :label="item.createTime" v-for="item in list" :key="item.notice_id"
                    @click="workflowInstanceClick(item.msg)">
                    <template #icon>
                        <div class="message-workflow-icon-wrap">
                            <van-icon class-prefix="cgsIcon" name="gongzuoliuchengtu"
                                class="iconfont message-workflow-icon" />
                        </div>
                    </template>
                    <template #title class="cell">
                        <div style="font-weight: bold; font-size: 15px">工作流</div>
                        <span v-html="item.msg" class="item_msg"></span>
                    </template>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>

<script>
    import {
        List,
        Cell,
        CellGroup,
        Empty,
        Badge,
        NavBar,
        Icon
    } from "vant";
    import {
        MessageList
    } from "@/api/message";
    import {
        getTaskCount
    } from "@/api/myProcess"

    export default {
        components: {
            vanList: List,
            vanCell: Cell,
            vanCellGroup: CellGroup,
            vanEmpty: Empty,
            vanBadge: Badge,
            vanNavBar: NavBar,
            vanIcon: Icon,
        },
        data() {
            return {
                list: [],
                rowId: "",
                tableId: "",
                loading: false,
                finished: false,
                daibanCount: 0
            };
        },
        methods: {
            workflowInstanceClick(msg) {
                let re = /href=['|"]\/(.*)['|"]\s*target=/;
                let route = re.exec(msg)[1];
                let [noticeRoute, tableId, rowId] = route.split("/");
                let [id] = tableId.split("?");
                if (noticeRoute === "workflowInstance") {
                    this.$router.push({
                        path: `/workflowInstance/${tableId}/${rowId}`
                    });
                } else if (noticeRoute === "workflowApprove") {
                    this.$router.push({
                        path: `/processform/${id}/approve`
                    });
                } else if (noticeRoute === "workflowFillIn") {
                    this.$router.push({
                        path: `/workflowFillIn/${id}`
                    });
                }
            },
            async onLoad() {
                let listage = await MessageList();
                this.list = listage.data.records;
                this.loading = false;
                this.finished = true;
            },
            goBack() {
                this.$router.go(-1);
            },
            async initTodo() {
                try {
                    let result = await getTaskCount()
                    if (result.code === 200) {
                        let _countObj = result.data
                        this.daibanCount = _countObj['1']

                    }
                } catch (err) {}
            }
        },
        async created() {
            this.$ws.on("send_notice", async (data) => {
                let messageli = await MessageList();
                this.list = messageli.data.records;
                this.initTodo()
            });
            this.$ws.on("clear_notice", async (data) => {
                let messageli = await MessageList();
                this.list = messageli.data.records;
                this.initTodo()
            });
            this.initTodo()
        },
    };
</script>
<style>
    .cell {
        /* margin-top: 10px; */
        margin-bottom: 10px;
    }

    .todo-cell {}

    .todo-cell .van-cell__right-icon {
        margin: auto;
    }

    .item_msg a {
        pointer-events: none;
    }

    .cgs-app-worksheet {
        background: #f5f5f5;
        display: flex;
        flex-direction: column;
    }

    .cgs-worksheet-header {
        /* color: #fff; */
        border-bottom: 1px solid #cfcfcf;
    }

    .cgs-worksheet-list-content {
        flex: 1;
        overflow: auto;
        padding-top: 10px;
    }

    .message-workflow-icon-wrap {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #0078d7;
        text-align: center;
        margin-right: 10px;
    }

    .message-workflow-icon {
        font-size: 20px;
        color: #fff;
    }

    .todo-cell-title {
        color: #1989fa;
        font-size: 18px;
    }

    .todo-cell-content {
        color: #FA5151
    }
</style>